// extracted by mini-css-extract-plugin
export default {"photo":"Photo_photo__qS+w-","rotatePhoto":"Photo_rotatePhoto__m5Wfc","attach":"Photo_attach__1l657"};